import { useMemoMergePropsWithDefault } from '@elliemae/ds-props-helpers';
import type { DSControlledDateTimePickerT } from '../react-desc-prop-types.js';
import { getDateStringFromDay, getMonthStringFromDay } from '../utils/dateHelpers.js';
import { defaultProps } from '../react-desc-prop-types.js';
// we have to merge the "default" nested default values with what the user gives us...

export const useGetDatePickerWithDefaultsProps = (
  props: DSControlledDateTimePickerT.Props,
): DSControlledDateTimePickerT.InternalProps => {
  const today = new Date();
  const todayString = getDateStringFromDay(today);
  const todayStartMonthString = getMonthStringFromDay(today);
  const emptyPickerStartingMonthUser = (props as DSControlledDateTimePickerT.DatePickerProps).emptyPickerStartingMonth;
  const canFillToday =
    emptyPickerStartingMonthUser === undefined || todayStartMonthString === emptyPickerStartingMonthUser;
  const newProps = canFillToday
    ? ({
        onCalendarOpenFocusedDay: todayString,
        emptyPickerStartingMonth: todayStartMonthString,
      } as DSControlledDateTimePickerT.DatePickerProps)
    : {};
  const defaultPropsWithToday: Partial<DSControlledDateTimePickerT.Props> = {
    ...defaultProps,
    ...newProps,
  };

  return useMemoMergePropsWithDefault<DSControlledDateTimePickerT.InternalProps>(props, defaultPropsWithToday);
};
